import loadBrandAndBillIssuerData from "./request/load-brand-and-bill-isser.service";
import loadBillIssuerDispatch from "./request/get-bill-issuer-dispatch.service";

import existRequest from "./request/exist-request.service";
import payRequest from "./request/pay-request.service";
import saveRequest from "./request/save-request.service";
import eventBus from "./common/eventBus";
import signIn from "./user/sign-in.service";
import StorageService from "./common/storage";
import getRequest from "./request/get-request.service";
import getUnSignedDocs from "./request/get-unsigned-documents";
import downloadUnSignedDocuments from "./request/download.unsigned-docs.service";
import saveMarketingData from "./user/save-marketing-data";
import updateProfile from "./user/update-profile";
import getMyDocuments from "./request/get-my-documents.service";
import cancelRequest from "./request/cancel-request.service";
import getDocumentDetail from "./request/get-document-detail";
import getManagerByBillIssuer from "./request/get-manager-by-bill-issuer.service";
import downloadMyDetailDocuments from "./request/download-my-detail-documents.service";
import getSitesMapInfo from "./home/sitesmap";
import * as eventStream from "./common/eventStream";

export const service = {
  loadBrandAndBillIssuerData,
  loadBillIssuerDispatch,
  existRequest,
  payRequest,
  eventBus,
  signIn,
  saveRequest,
  getRequest,
  StorageService,
  getUnSignedDocs,
  downloadUnSignedDocuments,
  saveMarketingData,
  updateProfile,
  createEventStreamListener: eventStream.createEventStreamListener,
  getMyDocuments,
  cancelRequest,
  getDocumentDetail,
  downloadMyDetailDocuments,
  getSitesMapInfo,
  getManagerByBillIssuer,
};
